export default {
  cwd: () => "/",
  env: {
    NO_COLOR: "true",
    FORCE_COLOR: "false"
  },
  argv: []
};
